export default __webpack_public_path__ + "static/media/carro_apoio_forno.6ed7f633.png";